import React from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import Fonts from "./style/fonts";
import { theme } from "./style/theme";
import "./style/recharts.css";
import "./language/i18n";
import Root from "./pages/root";
import { RecoilRoot } from "recoil";
import RecoilNexus from "recoil-nexus";

const container = document.getElementById("firedos-loeschmonitor-konfigurator");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <RecoilNexus />
      <ChakraProvider theme={theme} resetCSS={false}>
        <Fonts />
        <Root />
      </ChakraProvider>
    </RecoilRoot>
  </React.StrictMode>
);
